/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export interface CohortSummary {
  /** Total number of students in report */
  totalStudents: number;
  /** Students with recent activity */
  activeStudents: number;
  /** Students with no activity >7 days */
  stalledStudents: number;
  /** Students who completed the module */
  completedStudents: number;
  /** Average days since module start */
  avgModuleDay: number;
}
